import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../state";
import {
  IUrgentVisitState,
  urgentVisitActions,
  UrgentVisitStep,
  SelectedSlot,
  UrgentVisitBookingResponse,
} from "../../../state/urgent-visit";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import {
  ILocationItemResponse,
} from "../../../services/edit-hospital-location/edit-hospital-location.interface";

export const useUrgentVisitStore = () => {
  const dispatch = useDispatch();
  const state = useSelector(
    (root: IRootState) => root.urgentVisit as IUrgentVisitState,
  );

  const setStep = (step: UrgentVisitStep) => {
    dispatch(urgentVisitActions.setStep(step));
  };

  const setSelectedPets = (pets: IPetItemResponse[]) => {
    dispatch(urgentVisitActions.setSelectedPets(pets));
  };

  const setSelectedSlot = (slot: SelectedSlot | null) => {
    dispatch(urgentVisitActions.setSelectedSlot(slot));
  };

  const setSelectedLocation = (
    locationId: string,
    locationDetails: ILocationItemResponse,
  ) => {
    dispatch(urgentVisitActions.setSelectedLocation({
      locationId, locationDetails,
    }));
  };

  const setHomeLocationId = (id: string) => {
    dispatch(urgentVisitActions.setHomeLocationId(id));
  };

  const setPetReasons = (petId: string, reasons: string[]) => {
    dispatch(urgentVisitActions.setPetReasons({ petId, reasons }));
  };

  const setPetNotes = (petId: string, notes: string) => {
    dispatch(urgentVisitActions.setPetNotes({ petId, notes }));
  };

  const setCurrentPetIndex = (index: number) => {
    dispatch(urgentVisitActions.setCurrentPetIndex(index));
  };

  const setBookingResponse = (
    response: UrgentVisitBookingResponse,
  ) => {
    dispatch(urgentVisitActions.setBookingResponse(response));
  };

  const setPromoCodes = (codes: string[]) => {
    dispatch(urgentVisitActions.setPromoCodes(codes));
  };

  const setTimezone = (tz: string) => {
    dispatch(urgentVisitActions.setTimezone(tz));
  };

  const setSlotUnavailableMessage = (msg: string) => {
    dispatch(urgentVisitActions.setSlotUnavailableMessage(msg));
  };

  const setIsMultiPetOwner = (value: boolean) => {
    dispatch(urgentVisitActions.setIsMultiPetOwner(value));
  };

  const setSelectedDate = (epoch: number) => {
    dispatch(urgentVisitActions.setSelectedDate(epoch));
  };

  const setRescheduleAppointmentId = (id: string | null) => {
    dispatch(urgentVisitActions.setRescheduleAppointmentId(id));
  };

  const setPetAppointmentMap = (map: Record<string, string>) => {
    dispatch(urgentVisitActions.setPetAppointmentMap(map));
  };

  const resetUrgentVisit = () => {
    dispatch(urgentVisitActions.reset());
  };

  return {
    ...state,
    setStep,
    setSelectedPets,
    setSelectedSlot,
    setSelectedLocation,
    setHomeLocationId,
    setPetReasons,
    setPetNotes,
    setCurrentPetIndex,
    setBookingResponse,
    setPromoCodes,
    setTimezone,
    setSlotUnavailableMessage,
    setIsMultiPetOwner,
    setSelectedDate,
    setRescheduleAppointmentId,
    setPetAppointmentMap,
    resetUrgentVisit,
  };
};
